import { PlayerNumberMap } from '../../jscaip/PlayerMap';
import { TableUtils } from '../../jscaip/TableUtils';
import { HexagonalGameState } from '../../jscaip/state/HexagonalGameState';
import { YinshPiece } from './YinshPiece';
export class YinshState extends HexagonalGameState {
    sideRings;
    static SIZE = 11;
    constructor(board, sideRings, turn) {
        super(turn, board, YinshState.SIZE, YinshState.SIZE, [6, 4, 3, 2, 1], YinshPiece.EMPTY);
        this.sideRings = sideRings;
    }
    isInitialPlacementPhase() {
        return this.turn < 10;
    }
    countScores() {
        if (this.turn < 10) {
            return PlayerNumberMap.of(0, 0);
        }
        else {
            return this.sideRings;
        }
    }
    equals(other) {
        if (this === other) {
            return true;
        }
        if (this.turn !== other.turn) {
            return false;
        }
        if (this.sideRings.equals(other.sideRings) === false) {
            return false;
        }
        return TableUtils.equals(this.board, other.board);
    }
    getRingCoords(player) {
        const rings = [];
        this.forEachCoord((coord, content) => {
            if (content.isRing && content.player === player) {
                rings.push(coord);
            }
        });
        return rings;
    }
    isOnBoard(coord) {
        if (coord.isNotInRange(this.width, this.height)) {
            return false;
        }
        else {
            return this.getUnsafe(coord) !== YinshPiece.UNREACHABLE;
        }
    }
    setAtUnsafe(coord, value) {
        const newBoard = TableUtils.copy(this.board);
        newBoard[coord.y][coord.x] = value;
        return new YinshState(newBoard, this.sideRings, this.turn);
    }
}
